import React, { Component } from 'react'
import _ from 'lodash'
import { ALL_LANGUAGES } from '../../constants'
import searchStore from '../../mobx-store/search-store'
import moment from 'moment'

const imageSize = ''

const host = '//' + window.location.hostname + (window.location.port != 80 ? ':' + window.location.port : '')

const searchLanguaegs = langId => {
  return ALL_LANGUAGES.filter(lang => {
    if (lang['1'] === langId) {
      return lang.name
    }
  })
}

const getLangueges = languages => {
  if (languages.length < 1) return ''
  if (true) return ''
  let string
  const langArray = languages.map(langId => _.head(searchLanguaegs(langId)).name)
  if (languages.length > 1) {
    string = langArray.slice(0, -1).join(', ') + ' and  ' + langArray[langArray.length - 1]
  } else {
    string = _.head(langArray)
  }
  return string
}

function setUserRating(r) {
  let rating = Math.floor(r)
  let stars = []
  for (let i = 1; i <= 5; i++) {
    i <= rating
      ? stars.push(
          <span key={i} className="icon-star-filled">
            {' '}
          </span>
        )
      : stars.push(
          <span key={i} className="icon-star">
            {' '}
          </span>
        )
  }
  return <div className="rating">{stars}</div>
}

class AreaComponent extends Component {
  render() {
    const { destination } = this.props

    const coverPhoto = _.get(destination, 'photos[0].s3Url' + imageSize) || '/img/default-image.jpg'
    const location = _.get(destination, 'location.city')

    return (
      <div className="area-card">
        <div
          className="thumbnail"
          style={{
            background: `url(${coverPhoto}) no-repeat center`,
            backgroundColor: '#f2f2f2'
          }}
        />
        <div className="area">
          <div className="area__name">{location}&nbsp;</div>
        </div>
      </div>
    )
  }
}

class TourComponent extends Component {
  state = {
    isShown: false
  }

  getLangueges = arr => {
    let title = ''
    arr.forEach((item, index) => {
      const and = index === arr.length - 1 && index !== 0 ? ' and' : ''
      const splitter = index < arr.length - 2 && arr.length > 2 ? ',' : ''
      title += `${and} ${item + splitter}`
    })
    return title
  }

  handleOpenActivity = () => {
    const id = _.get(this.props.tour, 'id', '')
    console.log(this.props, id)
    window.open(`${host}/activity/${id}`, '_blank')
  }

  render() {
    const { tour } = this.props
    const temmArr = _.get(tour, 'languages', [])
    const languages = getLangueges(temmArr ? temmArr : [])
    const _pricePerPerson = _.get(tour, 'groupPrice', 0)
    const avatar = _.get(tour, 'tripGuide.userProfile.imageAvatar.s3Url', '/img/avatar.png')
    const privatePrice = _.get(tour, 'privateTourPrice', 0)
    const currency = _.get(tour, 'currency', 'USD')

    const pricePerPerson = _pricePerPerson % 1 === 0 ? _pricePerPerson : _pricePerPerson.toFixed(2)
    const reviews = _.get(tour, 'reviews', [])

    const userRating = _.get(tour, 'reviews', [])
      .map(e => e.score)
      .reduce(function(total, num) {
        return total + num
      }, 0)

    return (
      <div className="user-card">
        <div
          className="thumbnail"
          style={{
            background: `url(${_.get(tour, 'photos[0].s3Url', '/img/default-image.jpg')}) no-repeat center`,
            backgroundColor: '#f2f2f2',
            cursor: 'pointer'
          }}
          onClick={this.handleOpenActivity}
        />
        <div className="user">
          <img src={avatar} alt="" className="user-photo" onClick={this.handleOpenActivity} style={{ cursor: 'pointer' }} />
          <div className="user-info">
            <div
              className="user-info__name"
              title={_.get(tour, 'title')}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 200,
                cursor: 'pointer'
              }}
              onClick={this.handleOpenActivity}
            >
              {_.get(tour, 'title')}&nbsp;
            </div>
            <div className="user-info__language">{languages}&nbsp;</div>
            <div
              className="user-info__language"
              style={{ cursor: this.state.isShown ? 'default' : 'pointer' }}
              onClick={() => this.setState({ isShown: true })}
            >
              {this.state.isShown ? currency + ' ' + privatePrice : 'View private tour'}
            </div>
            <div className="user-info__language">
              {_.get(tour, 'currency')} {pricePerPerson} Per Person
            </div>
            <div className="stats" onClick={this.handleOpenActivity} style={{ cursor: 'pointer' }}>
              {setUserRating(userRating)}
              <div className="review-count">{reviews.length} Reviews</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class GuruComponent extends Component {
  getDestinations = arr => {
    let title = ''
    arr.forEach((item, index) => {
      const and = index === arr.length - 1 && index !== 0 ? ' and' : ''
      const splitter = index < arr.length - 2 && arr.length > 2 ? ',' : ''
      title += `${and} ${item.country + splitter}`
    })
    return title
  }

  handleOpenGuru = () => {
    const id = _.get(this.props.plan, 'id', '')
    window.open(`${host}/gurus/guru-profile/${id}`, '_blank')
  }

  render() {
    const { plan, country } = this.props

    //temp var - delete later
    const User = {
      name: 'John Doe',
      language: 'English',
      price: 10
    }

    //temp var - delete later if not needed
    const currencySymbols = {
      USD: '$',
      EUR: '€',
      RUB: '₽'
    }

    const fullName = `${_.get(plan, 'userProfile[0].firstName', '')}` // ${_.get(plan, 'userProfile[0].lastName', '')}`
    const temmArr = _.get(plan, 'plannerProfile.languages', [])
    const languages = getLangueges(temmArr ? temmArr : [])
    const reviews = _.get(plan, 'userProfile[0].reviews', [])
    const currency = currencySymbols[_.get(plan, 'plannerProfile.currency')] || ''
    const offers = _.get(plan, 'plannerProfile.planOffers', []).filter(item=>!country||item.location.country===country)
    const offer = offers.reduce((acc, item) => {
            let minPrice = item.price
            switch (item.paymentStructure) {
              case 'PayOneWeekPeriod':
                minPrice = item.price / 7
                break
              case 'PayTwoWeekPeriod':
                minPrice = item.price / 14
                break
              case 'PayThreeWeekPeriod':
                minPrice = item.price / 21
                break
              case 'PayForMonth':
                minPrice = item.price / 30            
                break
              case 'PayForMoreThanMonth':
                minPrice = item.price / 31            
            }
            return (minPrice > acc ? acc : minPrice)
          }, 'Current no cost')
    const _price = offer === 'Current no cost' ? 0 : offer
    const price = _price % 1 === 0 ? _price : _price.toFixed(2)
    const coverPhoto = _.get(plan, 'plannerProfile.photos[0].s3Url' + imageSize) || '/img/default-image.jpg'
    const title = 'Tailored trip to ' + this.getDestinations(_.get(plan, 'plannerProfile.locations', []))
    const imageAvatar = _.get(plan, 'userProfile[0].imageAvatar.s3Url') || '/img/default-profile-image.svg'
    const userRating = _.get(plan, 'userProfile[0].reviews', [])
      .map(e => e.score)
      .reduce(function(total, num) {
        return total + num
      }, 0)

    return (
      <div className="user-card">
        <div
          className="thumbnail"
          style={{
            background: `url(${coverPhoto}) no-repeat center`,
            backgroundColor: '#f2f2f2',
            cursor: 'pointer'
          }}
          onClick={this.handleOpenGuru}
        >
          <div className="title">
            <div className="customization" />
            <div className="trip">{title}</div>
          </div>
        </div>
        <div className="user">
          <img src={imageAvatar} alt="" className="user-photo" onClick={this.handleOpenGuru} style={{ cursor: 'pointer' }} />
          <div className="user-info" onClick={this.handleOpenGuru} style={{ cursor: 'pointer' }}>
            <div
              className="user-info__name"
              title={fullName || User.name}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 200
              }}
            >
              {fullName || User.name}&nbsp;
            </div>
            <div className="user-info__language">{languages}&nbsp;</div>
            <div className="user-info__price">{`Starting from - ${currency}${price} Per day`}</div>
            <div className="stats">
              {setUserRating(userRating)}
              <div className="review-count">{reviews.length} Reviews</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class BookedComponent extends Component {
  render() {
    const { booked } = this.props

    const fullName = `${_.get(booked, 'planPurchase.customizedPlan.tripGuru.userProfile.firstName')} ${_.get(
      booked,
      'planPurchase.customizedPlan.tripGuru.userProfile.lastName'
    )}`
    const coverPhoto = _.get(booked, 'planPurchase.customizedPlan.tripDetails.coverPhoto.s3Url' + imageSize) || '/img/default-image.jpg'
    const title = _.get(booked, 'planPurchase.customizedPlan.tripDetails.title')
    const userProfileImage =
      _.get(booked, 'planPurchase.customizedPlan.tripGuru.userProfile.imageAvatar.s3Url') || '/img/default-profile-image.svg'
    const reviews = _.get(booked, 'planPurchase.customizedPlan.tripGuru.userProfile.reviews', [])
    const userRating = _.get(booked, 'planPurchase.customizedPlan.tripGuru.userProfile.reviews', [])
      .map(e => e.score)
      .reduce(function(total, num) {
        return total + num
      }, 0)
    return (
      <div className="user-card">
        <div
          className="thumbnail"
          style={{
            background: `url(${coverPhoto}) no-repeat center`,
            backgroundColor: '#f2f2f2'
          }}
        >
          <div className="title">
            <div className="trip">{title}&nbsp;</div>
          </div>
        </div>
        <div className="user">
          <img src={userProfileImage} alt="" className="user-photo" />
          <div className="user-info">
            <div className="user-info__name">{fullName}&nbsp;</div>
            <div className="user-info__language">{'20 just booked'}</div>
            <div className="stats">
              {setUserRating(userRating)}
              <div className="review-count">{reviews.length} Reviews</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
/*eslint no-unreachable: "off"*/
export default class ActivityComponent extends Component {
  render() {
    let { data } = this.props

    switch (this.props.type) {
      case 'destination':
        return <AreaComponent destination={data} />
        break
      case 'plan':
        return <GuruComponent plan={data} country={this.props.country} dateRange={this.props.dateRange}/>
        break
      case 'tour':
        return <TourComponent tour={data} />
        break
      case 'booked':
        return <BookedComponent booked={data} />
        break
      default:
        break
    }
  }
}



// WEBPACK FOOTER //
// src/components/homepage/ActivityComponent.js